import environment from "src/utils/environment";

const { publicPath } = environment;

export default function decodeOgg(audio, arrayBuffer, onSuccess) {
  const typedArray = new Uint8Array(arrayBuffer);
  const decoderWorker = new Worker(
    window.location.origin + publicPath + "/decode-ogg/decoderWorker.min.js"
  );
  const wavWorker = new Worker(
    window.location.origin + publicPath + "/decode-ogg/waveWorker.min.js"
  );
  const desiredSampleRate = 8000;

  decoderWorker.postMessage({
    command: "init",
    decoderSampleRate: desiredSampleRate,
    outputBufferSampleRate: desiredSampleRate
  });

  wavWorker.postMessage({
    command: "init",
    wavBitDepth: 16,
    wavSampleRate: desiredSampleRate
  });

  decoderWorker.onmessage = (e) => {
    // null means decoder is finished
    if (e.data === null) {
      wavWorker.postMessage({ command: "done" });
    }

    // e.data contains decoded buffers as float32 values
    else {
      wavWorker.postMessage(
        {
          command: "encode",
          buffers: e.data
        },
        e.data.map((typedArray) => typedArray.buffer)
      );
    }
  };

  wavWorker.onmessage = (e) => {
    if (e.data.message === "page") {
      const dataBlob = new Blob([e.data.page], { type: "audio/wav" });

      audio.controls = true;
      audio.src = URL.createObjectURL(dataBlob);
      audio.play();
      onSuccess?.();
    }
  };

  decoderWorker.postMessage(
    {
      command: "decode",
      pages: typedArray
    },
    [typedArray.buffer]
  );
}
